module.exports = __webpack_public_path__ + "img/mobile-character-placeholder.0fd79521.webp";